export default "__VITE_ASSET__ggr$9wUa__"